/*
 * @Description:
 * @Author: lz
 * @Date: 2021-06-16 09:49:32
 * @LastEditTime: 2021-06-23 15:51:14
 * @LastEditors: lz
 */
import router from "./router";

import { getSiteType } from "@/utils/index";

router.beforeEach((to, from, next) => {
  console.log("111111111111111111111111111");
  console.log(to);

  let fsearch = from.query;
  for (let i in fsearch) {
    if (
      i == "tenant" ||
      i == "page" ||
      i == "uid" ||
      i == "tel" ||
      i == "cid" ||
      i == "corp" ||
      i == "scene" ||
      i == "parkId" ||
      i == "area"
    ) {
      sessionStorage.setItem(i, encodeURIComponent(fsearch[i]));
    }
  }
  let tsearch = to.query;
  for (let i in tsearch) {
    if (
      i == "tenant" ||
      i == "page" ||
      i == "uid" ||
      i == "tel" ||
      i == "cid" ||
      i == "corp" ||
      i == "scene" ||
      i == "parkId" ||
      i == "area"
    ) {
      sessionStorage.setItem(i, encodeURIComponent(tsearch[i]));
    }
  }
  //PC端（本项目）中加入了移动端页面的处理
  if (to.meta.isMobile) {
    //移动端适配处理
    let meta = document.getElementsByTagName("meta");
    meta[2].content =
      "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no";

    let html = document.getElementsByTagName("html");
    html[0].style.fontSize = "calc(100 / 750 * 100vw)";

    //移动端页面在pc打开的处理
    let site_type = getSiteType();
    if (site_type == "PC") {
      html[0].style.fontSize = "50px";
      html[0].style.maxWidth = "420px";
      html[0].style.margin = "0 auto";
    }
  } else {
    //pc端适配处理
    let meta = document.getElementsByTagName("meta");
    meta[2].content = "width=device-width,initial-scale=1.0";
  }
  next();
});
